import { Component, HostListener } from '@angular/core';
import { Event as RouterEvent, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { RouteInterceptorService } from './core/http/routeInterceptor.service';
//import { LogService } from './core/log/log.service';
declare var $: any;
@Component({
    selector: 'site-app',
    template: `
  	<div class="loader_container" style="display:none; z-index: 999;">
        <div class="loader">
            <div class="loader--dot"></div>
            <div class="loader--dot"></div>
            <div class="loader--dot"></div>
            <div class="loader--dot"></div>
            <div class="loader--dot"></div>
            <div class="loader--dot"></div>
            <div class="loader--text"></div>
        </div>
    </div>
    <div class="custom_container" style="display:none; z-index: 999;">
        <div class="loader">
            <div class="loader--dot"></div>
            <div class="loader--dot"></div>
            <div class="loader--dot"></div>
            <div class="loader--dot"></div>
            <div class="loader--dot"></div>
            <div class="loader--dot"></div>
            <div class="loader--text"></div>
        </div>
    </div>
    <router-outlet></router-outlet>
    <notifications></notifications>
  `
})
export class AppComponent {
    //  @HostListener('click', ['$event'])
    //   onClick(event: MouseEvent) {
    //     const input = event.target as HTMLElement;
    //     if(input.innerText){
    //       this.logService.logClickInfo('info',input.innerText);
    //     }
    //   }
    constructor(
        private routeInterceptorService: RouteInterceptorService,
        // private logService: LogService,
        public router: Router) {
    }
    ngOnInit() {
        this.routeInterceptorService.onNavigationEnd(route => {
            let requestPath = {};
            requestPath['previousUrl'] = this.routeInterceptorService.getPreviousUrl();
            requestPath['currentUrl'] = this.routeInterceptorService.getCurrentUrl();
            // this.logService.logHttpInfo('info',requestPath);

        });
        this.router.events.subscribe((event: RouterEvent): void => {
            this.navigationInterceptor(event);
        });
    }
    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            $('.loader_container').css('display', 'block');
        }
        if (event instanceof NavigationEnd) {
            $('.loader_container').css('display', 'none');
        }
    }
}